import { IconProps } from "./_types";

const SearchIcon = ({ size = 24, color = '#072567', ...other }: IconProps) => {
  return (
    <svg
      width={size}
      height={size * (28 / 24)}
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <path
        d="M6 2H13.5V8C13.5 8.84375 14.1562 9.5 15 9.5H21V23C21 24.6875 19.6406 26 18 26H6C4.3125 26 3 24.6875 3 23V5C3 3.35938 4.3125 2 6 2ZM15 2L21 8H15V2ZM15.75 16.25C15.75 13.7656 13.7344 11.75 11.25 11.75C8.76562 11.75 6.75 13.7656 6.75 16.25C6.75 18.7344 8.76562 20.75 11.25 20.75C12.0469 20.75 12.8438 20.5625 13.5 20.1406L15.3281 21.9688C15.75 22.3906 16.4531 22.3906 16.9219 21.9688C17.3438 21.5 17.3438 20.7969 16.9219 20.375L15.0938 18.5469C15.5156 17.8906 15.75 17.0938 15.75 16.25ZM11.25 18.5C10.4062 18.5 9.70312 18.0781 9.28125 17.375C8.85938 16.7188 8.85938 15.8281 9.28125 15.125C9.70312 14.4688 10.4062 14 11.25 14C12.0469 14 12.75 14.4688 13.1719 15.125C13.5938 15.8281 13.5938 16.7188 13.1719 17.375C12.75 18.0781 12.0469 18.5 11.25 18.5Z"
        fill={color}
      />
    </svg>
  );
};

export default SearchIcon;
